module.exports = __webpack_public_path__ + "static/media/home-site.60f54d1e.png";